/**
 * useMediaQuery — подписка на CSS-медиазапрос.
 *
 * Возвращает true, пока запрос совпадает с текущим окном.
 * Используется, чтобы на мобильных не применять десктопное
 * состояние сайдбара (класс "collapsed").
 */
import { useEffect, useState } from "react";

export function useMediaQuery(query) {
    const getMatch = () =>
        typeof window !== "undefined" && window.matchMedia
            ? window.matchMedia(query).matches
            : false;

    const [matches, setMatches] = useState(getMatch);

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return undefined;
        }

        const mediaQuery = window.matchMedia(query);
        const handleChange = (event) => setMatches(event.matches);

        setMatches(mediaQuery.matches);
        mediaQuery.addEventListener("change", handleChange);

        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [query]);

    return matches;
}

export default useMediaQuery;
